import merge from './nullableBooleanMerger';

function mergeCompatability(a, b) {
    return new VersionCompatability(
        merge(a.legends, b.legends),
        merge(a.kingdoms, b.kingdoms),
    );
}

export default class VersionCompatability {
    /**
     * @var {boolean|null} Is the given parser compatible with Legends?
     */
    legends
    /**
     * @var {boolean|null} Is the given parser compatible with Kingdoms?
     */
    kingdoms

    /**
     *
     * @param legends {boolean|null}
     * @param kingdoms {boolean|null}
     */
    constructor(legends, kingdoms) {
        this.legends = legends;
        this.kingdoms = kingdoms;
    }

    /**
     * Get weakest compatability.
     * @param list {VersionCompatability}
     * @returns {VersionCompatability}
     */
    static merge(...list) {
        return list.reduce((a, b) => mergeCompatability(a, b), list[0]);
    }
}
